module.exports = __webpack_public_path__ + "img/titimg2.28806000.png";